export default __webpack_public_path__ + "static/media/icon-print.f5ff3ec5.svg";